import React from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useTranslation } from "react-i18next";

import { useLoginThirdParty } from "../../apiHooks/auth";
import { fbColoredSvg } from "../../svgs";

const appID = "2502022626621856";

const CustomFacebookAuth: React.FC = () => {
  // translation
  const { t } = useTranslation();

  const { loginThirdParty } = useLoginThirdParty();

  const loginThirdPartyUser = (data) => {
    if (data.accessToken) {
      loginThirdParty({
        params: {
          email: data.email,
          username: data.name,
          vendor_name: "1",
          vendor_id: data.id,
          token: data.accessToken,
        },
      });
    }
  };

  const responseFacebook = (res) => {
    loginThirdPartyUser(res);
  };

  return (
    <FacebookLogin
      appId={appID}
      fields="name,email"
      scope="email"
      disableMobileRedirect
      callback={responseFacebook}
      render={(renderProps) => (
        <button onClick={renderProps.onClick}>
          {fbColoredSvg()} {t("facebookAuth")}
        </button>
      )}
    />
  );
};

export default CustomFacebookAuth;
